export function usePriceFormat() {
  const displayPrice = (price_type?: string, price?: string | number) => {
  if (price_type === 'fixed') {
    const numberPrice = Number(price)

    if (Number.isNaN(numberPrice)) {
      return ''
    }

    return Number.isInteger(numberPrice)
      ? String(numberPrice)
      : String(numberPrice)
  }

  if (price_type === 'agreement') {
    return 'DOGOVOR'
  }

  return ''
}

  const currencySymbol = (price_type?: string, currency_code?: string) => {
    if (price_type !== 'fixed') return ''
    return currency_code === 'EUR' ? '€' : (currency_code || '')
  }

  return { displayPrice, currencySymbol }
}
